import { IPagination, IPaginationLight } from '~/types/main';

export const paginationLightToPagination = (paginationLight: IPaginationLight, data: any[] = []): IPagination<any> => {
  return {
    data,
    from: null,
    to: null,
    path: '',
    first_page_url: '',
    last_page_url: '',
    next_page_url: null,
    prev_page_url: null,
    pages: [],
    loading: false,
    refreshing: false,
    avg_spending: 0,
    ...paginationLight,
  };
};
